import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { Link } from 'react-router-dom';
export default function ProjectNavbar({
projectIndex
})
{
    return (
    <nav className="navbar fixed-bottom navbar-light">
            <div className="container-fluid justify-content-center align-items-center">

                <Link 
                to={`/local/project/${projectIndex}/setting`}
                className="btn btn-link">
                <i className="bi bi-gear navicon"></i>
                </Link>

                <Link 
                to={`/local/${projectIndex}/Stats`}
                className="btn btn-link">
                <i className="bi bi-graph-up-arrow navicon"> </i>
                </Link>

                <Link 
                to={`/local/${projectIndex}/Calculator`}
                className="btn btn-link">
                <i className="bi bi-calculator-fill navicon"> </i>
                </Link>


                <Link 
                to={`/local/${projectIndex}/AddWords`}
                className="btn btn-link">
                <i className="bi bi-plus navicon"> </i>
                </Link>

            </div>
    </nav>

    )
}